import {
  FETCH_CITIES,
  FETCH_HOUSES_LIST,
  GET_DEFAULT_VALUES,
  GET_HOST_CANCELLATION_RULES,
  SET_HOUSE_DATA,
  SET_HOUSE_TYPE,
} from '../actions/types'

export interface HouseRegisterTypes {
  data: any
  loading: boolean
  page: number
}

interface ActionTypes {
  type: string
  data: any
  loading: boolean
  defaultData: any
}

const initialState = {
  data: null,
  loading: false,
  page: 1,
}

export const houseRegisterReducer = (
  state: HouseRegisterTypes = initialState,
  action: ActionTypes,
) => {
  switch (action.type) {
    case FETCH_HOUSES_LIST:
      return {
        ...state,
        data: {
          ...state.data,
          housesList: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    case FETCH_CITIES:
      return {
        ...state,
        data: {
          ...state?.data,
          citiesList: {
            data: {
              defaultCity: action.defaultData,
              searchedCity: action.data,
            },
            loading: action.loading,
          },
        },
      }
    case SET_HOUSE_TYPE:
      return {
        ...state,
        data: {
          ...state?.data,
          houseType: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    case GET_DEFAULT_VALUES:
      return {
        ...state,
        data: {
          ...state?.data,
          houseData: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    case SET_HOUSE_DATA:
      return {
        ...state,
        data: {
          ...state?.data,
          registerHouseData: {
            loading: action.loading,
          },
        },
      }
    case GET_HOST_CANCELLATION_RULES: {
      return {
        ...state,
        data: {
          ...state.data,
          hostCancellationRules: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    }
    default:
      return state
  }
}
